import React from 'react';
import { CircularProgress, TextField, TextFieldProps } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { themeColors } from '@ianesthesie-kit/config';

type SearchFieldProps = TextFieldProps & {
  loading?: boolean;
};

export const SearchField = ({
  loading,
  InputProps,
  ...props
}: SearchFieldProps) => (
  <TextField
    size="small"
    InputProps={{
      ...InputProps,
      startAdornment: <SearchIcon htmlColor={themeColors.slate[500]} />,
      endAdornment: loading ? (
        <CircularProgress size={18} thickness={5} />
      ) : (
        InputProps?.endAdornment
      )
    }}
    {...props}
  />
);
